module.exports = __webpack_public_path__ + "img/deal.f3c85708.png";